import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { Switch } from 'react-router-dom';
import b from 'b_';

import { AppDataProvider } from 'client/contexts/app-data';
import routes from 'client/routes';

import Debug from '@components/debug';
import AppMeta from '@components/app-meta';
import Metrika from '@components/metrika';
import LayoutRoute from '@components/layout-route';
import Favicon from '@components/favicon';

import './app.css';

export interface AppProps {
    data?: any;
    state?: any;
}

const class_ = b.with('app');

class App extends Component<AppProps> {
    public shouldComponentUpdate() {
        return true;
    }

    public render() {
        const { data } = this.props;
        const { desktopVersionAlways = false } = data;

        return (
            <AppDataProvider data={data}>
                <div className={class_()}>
                    <Helmet>
                        <html lang={data.lang} />
                        {desktopVersionAlways
                            ? <meta name="viewport" content="width=1025" />
                            : <meta name="viewport" content="width=device-width, initial-scale=1" />
                        }
                    </Helmet>
                    <Favicon />
                    <AppMeta />

                    <Switch>
                        {this.renderRoutes()}
                    </Switch>

                    <Metrika />
                    {data.debug && <Debug data={data} />}
                </div>
            </AppDataProvider>
        );
    }

    private renderRoutes() {
        return routes.map(route => <LayoutRoute key={route.path} {...route} />);
    }
}

export default App;
